import React from 'react';

import { Link } from '@eika/link';

import { Skademeldingstype } from '../../../types/generated-types';
import { getExternalUrlForSkadekategori, getExternalUrlForSkadetype } from '../../deep-link-handler';
import { Skadekategori } from '../../deep-link-handler/skadekategori';
import { eikaForsikringPhonenumber, LinkButton, phone } from '../utils';

export default (
    <div>
        <p>
            Har du vært utsatt for en trafikkulykke som har medført personskade, kan du melde skaden under{' '}
            <Link href={getExternalUrlForSkadekategori(Skadekategori.Kjoretoy)} linkType="inline">
                kjøretøy
            </Link>{' '}
            dersom bilen er forsikret hos oss. Er kjøretøyet forsikret i et annet forsikringsforetak, må du melde skaden
            der. I tillegg kan du melde skaden til oss under &quot;Personskade ved ulykke&quot;. Ønsker du veiledning
            kan du kontakte oss på telefon
        </p>
        <p>Ønsker du veiledning kan du kontakte oss på telefon: {phone(eikaForsikringPhonenumber)}</p>
        <LinkButton href={getExternalUrlForSkadetype(Skademeldingstype.PersonskadeAnnet)}>Meld skade</LinkButton>
    </div>
);
